import React from "react";
import SummaryDetailsItem from "../../../Common/SummaryDetailsItem/SummaryDetailsItem";
import SummaryDetailsProps from "../../../../../types/SummaryDetailsProps";

const SummaryDetailsMembership = ({ caseData }: SummaryDetailsProps) => {
  return (
    <>
      <SummaryDetailsItem fieldPath={"membershipType"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"reasonForDispute"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"contractNumber"} caseData={caseData} />
      {caseData.reasonForDispute === "priceIncrease" && (
        <>
          <SummaryDetailsItem fieldPath={"priceIncreaseAnnouncementDate"} caseData={caseData} fieldType={"date"} />
        </>
      )}
      {(caseData.reasonForDispute === "cancellationRefused" || caseData.reasonForDispute === "cancellationContractExtension") && (
        <>
          <SummaryDetailsItem fieldPath={"cancellationDate"} caseData={caseData} fieldType={"date"} />
          <SummaryDetailsItem fieldPath={"endOfContractDate"} caseData={caseData} fieldType={"date"} />
        </>
      )}
      {caseData.reasonForDispute === "cancellationRefused" && (
        <>
          <SummaryDetailsItem fieldPath={"opponentReactionToCancellation"} caseData={caseData} />
          {caseData.opponentReactionToCancellation === "differentDate" && (
            <SummaryDetailsItem fieldPath={"endOfContractDateOpponent"} caseData={caseData} fieldType={"date"} />
          )}
        </>
      )}

      <SummaryDetailsItem fieldPath={"feePaymentFrequency"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"fee"} caseData={caseData} fieldType={"money"} />
      <SummaryDetailsItem fieldPath={"numberUnpaidPeriods"} caseData={caseData} />
    </>
  );
};

export default SummaryDetailsMembership;
